<template>
    <div id="moduleAppList">
        <div class="top">
            <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
            <el-button size="medium" type="primary" @click="diffFunc()">对比家校通讯录</el-button>
            <template v-if="isInit">
                <a
                    :href="downLoadHref"
                    target="_blank"
                    download="activityName"
                >
                    <el-button
                        type="primary"
                        size="medium"
                    >导出多余学生及家长</el-button>
                </a>
                <el-button size="medium" type="danger" @click="batchDeleteHandler">清除企业微信多余学生/家长</el-button>
            </template>
            <el-button size="medium" type="primary" @click="initDepartFunc()">初始化年级及班级</el-button>
            <el-button size="medium" type="primary" @click="initStudentAndParentFunc()">初始化学生及家长</el-button>
            <el-button size="medium" type="primary" @click="clearFunc()">清空通讯录</el-button>

        </div>
        <div >
            <el-table
                :height="windowHeight - 205"
                :data="dataList" border
                style="width: 100%"
            >
                <el-table-column
                    label="年级"
                    align="center"
                    prop="gradeName"
                >
                </el-table-column>
                <el-table-column
                    label="班级"
                    align="center"
                    prop="departName"
                >
                </el-table-column>
                <el-table-column
                    label="学生姓名"
                    align="center"
                    prop="studentName"
                >
                </el-table-column>
                <el-table-column
                    label="用户名"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ scope.row.isParent == 1 ? scope.row.parentUserid : scope.row.studentUserid}}
                    </template>
                </el-table-column>


                <el-table-column
                    :label="`家长手机号${index}`"
                    align="center"
                    v-for="index in paretnCount"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.isParent == 1">{{scope.row.mobile}}</span>
                        <span v-else>
                            {{ scope.row.parents[index - 1] ? scope.row.parents[index - 1].mobile : '' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="问题类型"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ scope.row.isParent == 1 ? '家长' : '学生' }}账号问题
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog title="密钥设置" :visible.sync="isShowSecretDialog" :close-on-press-escape='false'
                   width="600px"
                   :lock-scroll="false"
                   :close-on-click-modal='false' :modal-append-to-body='false'>
            <div>
                <el-form ref="formData" :model="formData" :rules="formDataRule"
                         label-width="120px">
                    <el-form-item label="密钥" prop="secret">
                        <el-input v-model.trim="formData.secret" placeholder="请输入密钥" style="width: 400px;"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="isShowSecretDialog = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="diffConfirm()">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import BackTool from '@/components/BackTool';
    import windowResize from '@/mixins/windowResize';
    import baseMixin from '@/mixins/baseMixin';
    import {
        constrastBatchDelete,
        contrastResult,
        deleteTxlParentAndDepart,
        initDepart,
        initStudentAndParent
    } from '@/api/schoolManage';
    export default {
        name: 'externalContact',
        data() {
            return {
                schoolId: this.$route.query.schoolId,
                dataList: [],
                multipleSelection:[],
                moduleName: '',
                paretnCount: 0,
                isShowSecretDialog: false,
                formData: {
                    secret: ''
                },
                formDataRule: {
                    secret: [
                        {required: true, trigger: 'blur', message: '请输入密钥'}
                    ],
                },
                isInit: false
            }
        },
        computed: {
            downLoadHref() {
                return (
                    (global.command === "production"
                        ? "https://wyms.weixiaojia.cn/wyms"
                        : "https://wyms.weixiaojia.net/wyms") +
                    "/userContrast/downloadResult?&token=" +
                    this.$store.getters.token +
                    "&schoolId=" +
                    this.schoolId
                );
            },
        },
        components: {BackTool},
        mixins: [windowResize, baseMixin],
        methods: {
            initDepartFunc() {
                initDepart({
                    schoolId: this.schoolId
                })
                    .then(data => {
                        if(data.result) {
                            this.$message.success('初始化成功');
                        } else {
                            this.$message.error(data.msg);
                        }
                    })
            },
            initStudentAndParentFunc() {
                initStudentAndParent({
                    schoolId: this.schoolId
                })
                    .then(data => {
                        if(data.result) {
                            this.$message.success('初始化成功');
                        } else {
                            this.$message.error(data.msg);
                        }
                    })
            },
            clearFunc() {
                deleteTxlParentAndDepart({
                    schoolId: this.schoolId
                })
                    .then(data => {
                        if(data.result) {
                            this.$message.success('清空成功');
                        } else {
                            this.$message.error(data.msg);
                        }
                    })
            },
            diffFunc() {
                this.formData.secret = '';
                this.isShowSecretDialog = true;
            },
            diffConfirm() {
                this.$refs.formData.validate(isValid => {
                    if(isValid) {
                        contrastResult({
                            secret: this.formData.secret,
                            schoolId: this.schoolId
                        })
                            .then(res => res.data)
                            .then(data => {
                                if(data.result) {
                                    const pageData = data.data;
                                    pageData.wxParentMore.forEach(item => {
                                        item.isParent = 1;
                                    });
                                    const dataList = [...pageData.wxStudentMore, ...pageData.wxParentMore];
                                    let parentCount = 1;
                                    dataList.forEach(item => {
                                        parentCount = Math.max(parentCount, item.parents.length);
                                    });
                                    this.dataList = dataList;
                                    this.paretnCount = parentCount;
                                    this.isInit = true;
                                    this.isShowSecretDialog = false;
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                    }
                })

            },
            batchDeleteHandler() {
                this.$confirm('确认要删除吗？', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    lockScroll: false
                }).then(() => {
                    constrastBatchDelete({schoolId: this.schoolId})
                        .then(res => res.data)
                        .then(data => {
                            if(data.result) {
                                this.$message.success('删除成功');
                                this.isInit = false;
                                this.diffConfirm();
                            }
                        })
                });
            },
        }
    }
</script>

<style lang="scss" scoped>

    #moduleAppList{
        padding: 12px;
        .top {
            padding-bottom: 10px;
            a {
                color: #409EFF;
            }
        }}
</style>



// WEBPACK FOOTER //
// src/views/schoolManage/externalContact.vue